import { Button, Container } from 'react-bootstrap';
import React, { useState } from 'react';

import { AiFillGithub } from 'react-icons/ai';
import { FiPhoneCall } from 'react-icons/fi';
import { MdEmail } from 'react-icons/md';
import SocialMedia from '../SocialMedia';
import emailjs from '@emailjs/browser';

const Contact = () => {

    const [subject, setsubject] = useState("")
    const [from_name, setfrom_name] = useState("")
    const [user_email, setuser_email] = useState("")
    const [message, setmessage] = useState("")

    const getData = () => {
        if (message == "" || subject == "" || from_name == "" || user_email == "") {
            alert("Fill all the details")
        } else {
            var templateParams = {
                subject: subject,
                from_name: from_name,
                user_email: user_email,
                message: message
            };

            emailjs.send('service_d9lb8bd', 'template_lo12xmi', templateParams, "Tl4H9wLKfGddwg0Lw")
                .then(function (response) {
                    alert("Contact Success")
                    // console.log('SUCCESS!', response.status, response.text);
                }, function (error) {
                    console.log('FAILED...', error);
                });
        }

    }

    return (
        <Container id="contact" fluid className="about-section">
            <Container>
                {/*Section: Contact v.2*/}
                <section className="mb-4">
                    {/*Section heading*/}
                    <h2 className="h1-responsive font-weight-bold text-center my-4">Contact us</h2>
                    {/*Section description*/}
                    <p className="text-center w-responsive mx-auto mb-5">Do you have any questions? Please do not hesitate to contact us directly.</p>
                    <div className="row">
                        {/*Grid column*/}
                        <div className="col-md-9 mb-md-0 mb-5">
                            <form id="contact-form" name="contact-form" action="mail.php" method="POST">
                                {/*Grid row*/}
                                <div className="row">
                                    {/*Grid column*/}
                                    <div className="col-md-6">
                                        <div className="md-form mb-0">
                                            <input type="text" id="name" name="name" className="form-control" onChange={(e) => setfrom_name(e.target.value)} />
                                            <label htmlFor="name" className>Your name</label>
                                        </div>
                                    </div>
                                    {/*Grid column*/}
                                    {/*Grid column*/}
                                    <div className="col-md-6">
                                        <div className="md-form mb-0">
                                            <input type="text" id="email" name="email" className="form-control" onChange={(e) => setuser_email(e.target.value)} />
                                            <label htmlFor="email" className>Your email</label>
                                        </div>
                                    </div>
                                    {/*Grid column*/}
                                </div>
                                {/*Grid row*/}
                                {/*Grid row*/}
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="md-form mb-0">
                                            <input type="text" id="subject" name="subject" className="form-control" onChange={(e) => setsubject(e.target.value)} />
                                            <label htmlFor="subject" className>Subject</label>
                                        </div>
                                    </div>
                                </div>
                                {/*Grid row*/}
                                {/*Grid row*/}
                                <div className="row">
                                    {/*Grid column*/}
                                    <div className="col-md-12">
                                        <div className="md-form">
                                            <textarea type="text" id="message" name="message" rows={2} className="form-control md-textarea" onChange={(e) => setmessage(e.target.value)} />
                                            <label htmlFor="message">Your message</label>
                                        </div>
                                    </div>
                                </div>
                                {/*Grid row*/}
                            </form>
                            <div className="text-center text-md-left">
                                <Button className="btn btn-primary" onClick={() => getData()}>Send</Button>
                            </div>
                            <div className="status" />
                        </div>
                        {/*Grid column*/}
                        {/*Grid column*/}
                        <div className="col-md-3 text-center">
                            <ul className="list-unstyled mb-0">
                                <li><i className="fas fa-map-marker-alt fa-2x" />
                                    <p>Aurangabad, Maharashtra, India</p>
                                </li>
                            </ul>
                            <li className="social-icons">
                                <a
                                    href="mailto:jubershaikh2307@gmail.com"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="icon-colour home-social-icons"
                                >
                                    <MdEmail className="social-icon" />
                                </a>
                            </li>
                            <li className="social-icons">
                                <a
                                    href="tel:+918055154446"
                                    rel="noreferrer"
                                    className="icon-colour home-social-icons"
                                >
                                    <FiPhoneCall className="social-icon" />
                                </a>
                            </li>
                        </div>
                        {/*Grid column*/}
                    </div>
                </section>
                {/*Section: Contact v.2*/}

            </Container>
        </Container>
    );
};

export default Contact;